import React from 'react';
import PropTypes from 'prop-types';

// Images
import registryPromoImg from '../../../../assets/images/website/registry/promo-overlay-registry.png';
import RSVPPromoImg from '../../../../assets/images/website/rsvp/rsvp-promo-image.png';

/**
 * WebsitePreviewPromo
 *
 * @param {string} promoImage  - src of promo image
 * @param {string} promoImageAlt - alt attribute for promo image
 * @param {string} className - any additional class name for website-preview-promo
 * @param {component} promoCustomContent - component to provide any custom html
*/

const WebsitePreviewPromo = (props) => {
  const { pageType, promoCustomContent, className } = props;
  const pageName = pageType.toLowerCase();
  let promoImage;
  let promoImageAlt;

  if (pageType === 'REGISTRY') {
    promoImage = registryPromoImg;
    promoImageAlt = 'Gifts, experiences, and honeymoon funds in one place';
  }

  if (pageType === 'RSVP') {
    promoImage = RSVPPromoImg;
    promoImageAlt = 'RSVP Tracking';
  }

  return (
    <div className={`website-preview-promo promo__${pageName} ${className}`}>
      <div className="promo__wrap">
        {promoCustomContent ? (
          {promoCustomContent}
        ) : (
          <img className="promo__image" src={promoImage} alt={promoImageAlt} />
        )}
      </div>
    </div>
  );
};

WebsitePreviewPromo.propTypes = {
  pageType: PropTypes.string,
  promoCustomContent: PropTypes.element,
  className: PropTypes.string,
};

WebsitePreviewPromo.defaultProps = {
  pageType: '',
  promoCustomContent: null,
  className: '',
};

export default WebsitePreviewPromo;



// WEBPACK FOOTER //
// ./src/components/manage/website/WebsitePreview/WebsitePreviewPromo.jsx